import { useMemo } from 'react';
import { TagSource } from './type';
import { useTranslate } from '@tolgee/react';

export const useTagSourceLabel = () => {
  const { t } = useTranslate();
  return useMemo<Record<TagSource, string>>(() => {
    return {
      CONVERSATION: t('header.会话'),
      ORDER: t('ViewsChat.弃单'),
      REVIEW: t('review.评价'),
      TODO: t('todo.待办'),
    };
  }, [t]);
};
